"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELETE_ONE_TIME_ITEM = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var get_customer_subscriptions_1 = require("../queries/get-customer-subscriptions");
exports.DELETE_ONE_TIME_ITEM = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation DeleteOneTimeItem($id: Int!) {\n    deleteOneTimeItem(id: $id) ", "\n  }\n"], ["\n  mutation DeleteOneTimeItem($id: Int!) {\n    deleteOneTimeItem(id: $id) ", "\n  }\n"])), get_customer_subscriptions_1.GROUPED_SUBSCRIPTIONS_QUERY);
var templateObject_1;
